<div class="rs-flex rs-flex-dir-col rs-justify-center rs-flex-middle rs-mh-m25">
  <div
    class="rs-spinner"
    role="alert"
    aria-live="polite"
    aria-label="Loading"
    title="Loading"
    aria-busy="true"
  ></div>
</div>
